import Work1 from "../../assets/work-1.png";
import Work2 from "../../assets/work-2.png";
import Work3 from "../../assets/work-3.png";
import Work4 from "../../assets/work-4.PNG";
import Work5 from "../../assets/work-5.png";
import Work6 from "../../assets/work-6.png";
import Work7 from "../../assets/work-7.png";
import Work8 from "../../assets/work-8.png";
import Work9 from "../../assets/work-9.png";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "IoT: Garage Door Opener with Authentication",
        category: "IoT/Hardware",
        link: "https://github.com/aidanharries/Garage-Door-Opener-with-Authentication.git",
    },
    {
        id: 2,
        image: Work2,
        title: "FPGA: Maze Game",
        category: "IoT/Hardware",
        link: "https://github.com/aidanharries/FPGA-Maze-Game.git",
    },
    {
        id: 3,
        image: Work3,
        title: "Unity: Senior Design Project",
        category: "Games",
        link: "https://github.com/aidanharries/Unity-Senior-Design-Project.git",
    },
    {
        id: 4,
        image: Work4,
        title: "Monogame: Skull Island",
        category: "Games",
        link: "https://github.com/aidanharries/Monogame-Skull-Island.git",
    },
    {
        id: 5,
        image: Work5,
        title: "Neural Network: Wine Classification",
        category: "AI/Machine Learning",
        link: "https://github.com/aidanharries/Neural-Network-Wine-Classification.git",
    },
    {
        id: 6,
        image: Work6,
        title: "Advanced Regression: House Prices",
        category: "AI/Machine Learning",
        link: "https://github.com/aidanharries/Advanced-Regression-House-Prices.git",
    },
    {
        id: 7,
        image: Work7,
        title: "Machine Learning: Olympic Medals Prediction",
        category: "AI/Machine Learning",
        link: "https://github.com/aidanharries/Machine-Learning-Olympic-Medals-Prediction.git",
    },
    {
        id: 8,
        image: Work8,
        title: "Operating Systems: One Program, Three Ways",
        category: "Systems/Design",
        link: "https://github.com/aidanharries/Operating-Systems-One-Program-Three-Ways.git",
    },
    {
        id: 9,
        image: Work9,
        title: "Computer Design: Simple CPU",
        category: "Systems/Design",
        link: "https://github.com/aidanharries/Computer-Design-Simple-CPU.git",
    },
];

export default Menu